import React, { useState, useEffect } from "react";
import { Form, Input, InputNumber, Button, Row, Col, notification } from "antd";
import {
  TagOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import { updateStudentConditionApi } from "../../../../api/studentCondition";
import { getAccessToken } from "../../../../api/auth";

import "./EditStudentConditionForm.scss";

export default function EditStudentConditionForm(props) {
  const { studentCondition, setIsVisibleModal, setReloadStudentConditions } = props;
  const [ studentConditionData, setStudentConditionData] = useState({});

  //trae los datos de ciclo del estudiante
  useEffect(() => {
    setStudentConditionData({
      studentCondition_code: studentCondition.studentCondition_code,
      description: studentCondition.description,
    });
  }, [studentCondition]);

  //Verifica que no exista errores en los datos que se deben validar
  const isFormValid = (e) => {
    let errorExists = false;
    if (!studentConditionData.description) {
      notification["error"]({
        message: "Obligatorio: descripción.",
      });
      errorExists = true;
    } else {
      errorExists = false;
    }
    return errorExists;
  };

  const updateStudentCondition = (e) => {
    e.preventDefault();
    const error = isFormValid();
    if (!error) {
      const token = getAccessToken();
      let studentConditionUpdate = studentConditionData; //es let porque se va actualizando

      updateStudentConditionApi(token, studentConditionUpdate, studentCondition._id).then(
        (result) => {
          if (
            result.message === "ERR_CONNECTION_REFUSED" ||
            result.message === "Failed to fetch" ||
            result.message === undefined
          ) {
            notification["error"]({
              message: "Servidor caido",
            });
            setIsVisibleModal(true);
          } else if (result.code !== 200) {
            notification["error"]({
              message: result.message,
            });
            setIsVisibleModal(true);
          } else {
            notification["success"]({
              message: result.message, //el mensaje que viene del server
            });
            //console.log("respuesta: " + result.message);
            setIsVisibleModal(false);
            setReloadStudentConditions(true);
          }
        }
      );
    }
  };

  return (
    <div className="edit-studentcondition-form">
      <EditForm
        studentConditionData={studentConditionData}
        setStudentConditionData={setStudentConditionData}
        updateStudentCondition={updateStudentCondition}
      />
    </div>
  );
}

function EditForm(props) {
  const {
    studentConditionData,
    setStudentConditionData,
    updateStudentCondition
  } = props;

  return (
    <Form className="form-edit" onSubmit={updateStudentCondition}>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={12}>
          <label className="control-label">
            Código
          </label>
          <Form.Item>
            <InputNumber
              prefix={<TagOutlined />}
              placeholder="Automático"
              value={studentConditionData.studentCondition_code}
              onChange={(e) => setStudentConditionData({ ...studentConditionData, studentCondition_code: e })}
              style={{ width: "100%" }}
              disabled={true}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <label className="control-label">
            <span className="control-required">* </span>Descripción
          </label>
          <Form.Item>
            <Input
            //   placeholder="descripción"
              value={studentConditionData.description}
              onChange={(e) =>
                setStudentConditionData({ ...studentConditionData, description: e.target.value })
              }
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          className="btn-submit"
          onClick={updateStudentCondition}
        >
          Actualizar
        </Button>
      </Form.Item>
    </Form>
  );
}
